const en = {
  welcome: 'Welcome',
  home: 'Home',
  search: 'Search',
  favorites: 'Favorites',
  profile: 'Profile',
};

export default en;